// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing030({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/030/01_241216_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/030/01_241216_02.gif`}
      // img3Path={`${process.env.REACT_APP_CDN_BASE}/images/030/01_241216_04.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/030/01_241216_03.jpg`} // 스텝 변경되는 이미지
      formFieldColor="white"
      qOptionColor="teal"
      questionType="btn"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/030/postBTN.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing030;
